module.exports = __webpack_public_path__ + "static/media/minus.83bf9c48.svg";